import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { u8aToHex } from '@polkadot/util';
import { Base } from "../codec/Base.mjs";
import { DEFAULT_VERSION } from "./constants.mjs";
var VERSIONS = ['ExtrinsicPayloadUnknown', // v0 is unknown
'ExtrinsicPayloadUnknown', 'ExtrinsicPayloadUnknown', 'ExtrinsicPayloadUnknown', 'ExtrinsicPayloadV4'];
/**
 * @name GenericExtrinsicPayload
 * @description
 * A signing payload for an [[Extrinsic]]. For the final encoding, it is variable length based
 * on the contents included
 */

export var GenericExtrinsicPayload =
/*#__PURE__*/
function (_Base) {
  _inherits(GenericExtrinsicPayload, _Base);

  function GenericExtrinsicPayload(registry, value) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        version = _ref.version;

    _classCallCheck(this, GenericExtrinsicPayload);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericExtrinsicPayload).call(this, registry, GenericExtrinsicPayload.decodeExtrinsicPayload(registry, value, version)));
  }
  /** @internal */


  _createClass(GenericExtrinsicPayload, [{
    key: "eq",

    /**
     * @description Compares the value of the input to see if there is a match
     */
    value: function eq(other) {
      return this._raw.eq(other);
    }
    /**
     * @description Sign the payload with the keypair
     */

  }, {
    key: "sign",
    value: function sign(signerPair) {
      var signature = this._raw.sign(signerPair); // This is extensible, so we could quite readily extend to send back extra
      // information, such as for instance the payload, i.e. `payload: this.toHex()`
      // For the case here we sign via the extrinsic, we ignore the return, so generally
      // this is applicable for external signing


      return {
        signature: u8aToHex(signature)
      };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      return this._raw.toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toHex();
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.toHex();
    }
    /**
     * @description Returns a serialized u8a form
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      // call our parent, with only the method stripped
      return _get(_getPrototypeOf(GenericExtrinsicPayload.prototype), "toU8a", this).call(this, isBare ? {
        method: true
      } : false);
    }
  }, {
    key: "blockHash",

    /**
     * @description The block [[Hash]] the signature applies to (mortal/immortal)
     */
    get: function get() {
      return this._raw.blockHash;
    }
    /**
     * @description The [[ExtrinsicEra]]
     */

  }, {
    key: "era",
    get: function get() {
      return this._raw.era;
    }
    /**
     * @description The genesis block [[Hash]] the signature applies to
     */

  }, {
    key: "genesisHash",
    get: function get() {
      // NOTE only v3+
      return this._raw.genesisHash || this.registry.createType('Hash');
    }
    /**
     * @description The [[Raw]] contained in the payload
     */

  }, {
    key: "method",
    get: function get() {
      return this._raw.method;
    }
    /**
     * @description The [[Index]]
     */

  }, {
    key: "nonce",
    get: function get() {
      return this._raw.nonce;
    }
    /**
     * @description The specVersion as a [[u32]] for this payload
     */

  }, {
    key: "specVersion",
    get: function get() {
      // NOTE only v3+
      return this._raw.specVersion || this.registry.createType('u32');
    }
    /**
     * @description The [[Balance]]
     */

  }, {
    key: "tip",
    get: function get() {
      // NOTE from v2+
      return this._raw.tip || this.registry.createType('Compact<Balance>');
    }
    /**
     * @description The transaction version as a [[u32]] for this payload
     */

  }, {
    key: "transactionVersion",
    get: function get() {
      // NOTE only v4+
      return this._raw.transactionVersion || this.registry.createType('u32');
    }
  }], [{
    key: "decodeExtrinsicPayload",
    value: function decodeExtrinsicPayload(registry, value) {
      var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_VERSION;

      if (value instanceof GenericExtrinsicPayload) {
        return value._raw;
      }

      return registry.createType(VERSIONS[version] || VERSIONS[0], value, {
        version: version
      });
    }
  }]);

  return GenericExtrinsicPayload;
}(Base);